import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';

const offerings = [
  { title: "Buy-Side Advisory", icon: "ShoppingCart", desc: "Strategic target identification and acquisition management for corporate expansion." },
  { title: "Sell-Side Advisory", icon: "TrendingUp", desc: "Maximizing shareholder value through structured exit processes and premium positioning." },
  { title: "Due Diligence", icon: "Search", desc: "Rigorous institutional-grade analysis of financial, operational, and structural risks." },
  { title: "Valuation & Structuring", icon: "PieChart", desc: "Sophisticated financial modeling to ensure deal integrity and long-term viability." },
  { title: "Cross-Border Transactions", icon: "Globe", desc: "Navigating international regulations and cultural complexities in global deal-making." },
  { title: "Post-Merger Integration", icon: "Layers", desc: "Ensuring organizational synergy and value realization after the transaction closes." },
  { title: "Strategic Partnerships", icon: "Users", desc: "Structuring joint ventures and alliances that drive mutual competitive advantages." },
  { title: "Corporate Restructuring", icon: "RefreshCw", desc: "Optimizing entity structures for tax efficiency, risk mitigation, and growth." }
];

const MAOfferings = () => {
  return (
    <section className="py-24 bg-brand-black">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center mb-20">
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight text-white mb-6">Institutional Offerings</h2>
          <p className="text-gray-400 max-w-2xl mx-auto font-light">Comprehensive M&A solutions tailored for mid-market and enterprise-scale transactions.</p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {offerings.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.05 }}
              whileHover={{ y: -5 }}
              className="group relative p-8 bg-brand-gray/20 border border-white/5 hover:border-brand-gold/40 transition-all duration-500 overflow-hidden"
            >
              <div className="absolute top-0 right-0 p-4 opacity-5 group-hover:opacity-20 transition-opacity">
                <SafeIcon name={item.icon} className="text-6xl text-white" />
              </div>
              <div className="relative z-10">
                <div className="w-12 h-12 flex items-center justify-center bg-brand-gold/10 text-brand-gold rounded-lg mb-6 group-hover:bg-brand-gold group-hover:text-white transition-all duration-500">
                  <SafeIcon name={item.icon} className="text-2xl" />
                </div>
                <h3 className="text-xl font-bold text-white mb-4">{item.title}</h3>
                <p className="text-sm text-gray-400 leading-relaxed font-light">{item.desc}</p>
              </div>
              <div className="absolute bottom-0 left-0 h-1 w-0 bg-brand-gold group-hover:w-full transition-all duration-700"></div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MAOfferings;